import { CreditCard, CreditCardType } from "../types/CreditCard";
import { startNumberDiners } from "../constants";
import CreditCards from "../functions/creditCards";

export class CreditCardDiners implements CreditCard {
  getType(): CreditCardType {
    return CreditCardType.Diners;
  }
  compare(number?: string): boolean {
    return CreditCards.compare(startNumberDiners, number);
  }
  getImageUrl() {
    return `${process.env.PUBLIC_URL}/assets/creditcards/diners.png`;
  }
}
